import { ActionType } from '../constants/ActionTypes';
import config from '../constants/Configs';
import { Constants } from '../constants/Constants';
import { RestPath } from '../constants/SitePaths';
import axios from 'axios';

export const getBusinessRulesBegin = (data) => ({
    type: ActionType.GET_BUSINESS_RULES_BEGIN,
    payload: data
});
export const getBusinessRulesError = (data) => ({
    type: ActionType.GET_BUSINESS_RULES_ERROR,
    payload: data
});
export const getBusinessRulesSuccess = (data) => ({
    type: ActionType.GET_BUSINESS_RULES_SUCCESS,
    payload: data
});

export function getBusinessRules() {
    return dispatch => {
        dispatch(getBusinessRulesBegin())
        
        return axios({
            method: Constants.GET,
            url: config.BASE_URL + RestPath.GET_BUSINESS_RULES
        }).then((response) => {
            dispatch(getBusinessRulesSuccess(response.data));
            return response.data;
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getBusinessRulesError(error.response.data));
                } else {
                    dispatch(getBusinessRulesError(error));
                }
            });

    };
}
